<template>
  <div class="flex-grid row forecast-days">
    <ForecastDay
      class="col data-block"
      v-for="(day, index) in forecastDays"
      :day="day"
      :index="index"
      :key="index"
    />
  </div>
</template>

<script>
import ForecastDay from './ForecastDay.vue';

export default {
  name: 'WeatherForecast',
  props: ['forecastDays'],
  components: { ForecastDay },
};
</script>
